import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import {
  PasswordField,
  SButton,
  SContainer,
  SError,
  SFormControl,
  SParagraph,
  STitle,
} from "../../components/BasicComponents";
import AppNavbar from "../../components/Navbars/AppNavbar";
import { AuthContext } from "../../context/AuthContext";
import { toastSuccess } from "../../utils/Toast";
import Loading from "../../components/Loading/Loading";
import { te } from "../../utils/errorsTranslation";

const RegisterPage = () => {
  const { t } = useTranslation("", { keyPrefix: "auth.register" });

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registrationError, setRegistrationError] = useState("");

  const { registerUser, loading, error, resetError } = useContext(AuthContext);
  const history = useHistory();

  const onClickRegister = (e) => {
    e.preventDefault();
    setRegistrationError("");

    if (password !== confirmPassword) {
      setRegistrationError(t("error1"));
      return;
    }

    if (email !== confirmEmail) {
      setRegistrationError(t("error2"));
      return;
    }

    registerUser({
      email: email,
      password: password,
      firstName: firstName,
      lastName: lastName,
    }).then((user) => {
      if (user) {
        history.push("/login");
        setRegistrationError("");
        toastSuccess(t("success"));
      }
    });
  };

  useEffect(() => {
    return () => resetError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <SContainer dark="true" fluid fill="true" className="d-flex flex-column">
          <Row>
            <AppNavbar dark="true" />
          </Row>

          <Container className="m-auto">
            <Col xl={4} lg={5} md={8} sm={10} className="d-flex flex-column flex-grow-1 justify-content-center">
              <STitle className="fs-1 fw-bolder mb-4 p-2 text-uppercase">{t("title")}</STitle>
              <Form className="p-2" onSubmit={onClickRegister}>
                <Form.Group className="p-2">
                  <SFormControl
                    required
                    placeholder={t("first_name")}
                    className="my-3 fs-5"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <SFormControl
                    required
                    placeholder={t("last_name")}
                    className="my-3 fs-5"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  <SFormControl
                    required
                    type="email"
                    placeholder={t("email")}
                    className="my-3 fs-5"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <SFormControl
                    required
                    type="email"
                    placeholder={t("confirm_email")}
                    className="my-3 fs-5"
                    // disable on paste in confirm email to prevent user from accidentally pasting in the wrong email
                    onPaste={(e) => e.preventDefault()}
                    onChange={(e) => setConfirmEmail(e.target.value)}
                  />
                  <PasswordField required onChange={(e) => setPassword(e.target.value)} />
                  <PasswordField
                    required
                    // not disabling on paste in confirm password to allow user to paste complex passwords from password managers
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <SButton type="submit" dark="true" className="mt-3 w-100 fs-5">
                    {t("register")}
                  </SButton>
                  {registrationError && <SError className="mt-3">{registrationError}</SError>}
                  {error && <SError className="mt-3">{te(error.message)}</SError>}
                  <SParagraph className="w-100 text-center mt-1 mb-0">
                    {t("already_account")} <Link to="/login">{t("sign_in")}</Link>
                  </SParagraph>
                </Form.Group>
              </Form>
            </Col>
          </Container>
        </SContainer>
      )}
    </>
  );
};

export default RegisterPage;
